import { use } from "i18next";
import { IApprovedGymsData, IGymData } from "../api/types";
import $api from "../http";
import { IGymListing } from "../models/GymListing";

class GymListingServiceClass {
  getAll(data: IApprovedGymsData, userId?: string | null) {
    const readyParams: any = {
      ...data,
    };

    if (Array.isArray(data?.facilities) && data.facilities.length > 0) {
      readyParams.facilities = data.facilities.join(",");
    }

    if (Array.isArray(data?.categoryIds) && data.categoryIds.length > 0) {
      readyParams.categoryIds = data.categoryIds.join(",");
    }

    return $api.get<IGymListing[]>("api/gym-listing/all-approved", {
      params: readyParams,
    });
  }

  getById({ id, userId }: IGymData) {
    return $api.get<IGymListing>(`api/gym-listing/by-id/${id}?userId=${userId}`);
  }

  notificationForComingSoonGym(gymListingId: string) {
    return $api.post<{}>("api/user-gym-listing-notification", {
      gymListingId,
    });
  }
}

export const GymListingService = new GymListingServiceClass();
